function NotFound() {
  return (
    <>
      <div className="title has-text-danger-dark has-text-centered mt-6 container">
        404 Not found! :(
      </div>
    </>
  );
}

export default NotFound;
